<router-outlet />
<app-cookie-banner />
<app-segov-sigepo-spinner-std></app-segov-sigepo-spinner-std>
